import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme';

export const RESET_PASSWORD_REQUEST_CLASS_NAME = 'ResetPasswordRequest';
export const RESET_PASSWORD_REQUEST_CLASS_SLOTS = ['root'] as const;

export type ResetPasswordRequestClassSlot =
	typeof RESET_PASSWORD_REQUEST_CLASS_SLOTS[number];

export interface ResetPasswordRequestClasses {
	root: string;
}

export type ResetPasswordRequestClassKey = keyof ResetPasswordRequestClasses;

export const getResetPasswordRequestUtilityClass = (slot: string) =>
	generateUtilityClass(RESET_PASSWORD_REQUEST_CLASS_NAME, slot);

export const resetPasswordRequestClasses = generateUtilityClasses<
	keyof ResetPasswordRequestClasses
>(RESET_PASSWORD_REQUEST_CLASS_NAME, ['root']);
export default resetPasswordRequestClasses;
